import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class RealTimeAAMSConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getSessionUpdateTopic(): string {
		return this.configService.get((x) => x.gaming.aamsGameData?.sessionUpdateTopic, "realtime-aams-session");
	}

	isEnabled(): boolean {
		return this.configService.get((x) => x.gaming.aamsGameData?.isEnabled, false);
	}
}
